import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as VisaBase2Module from '@Modules/interfaceManagement/visaBase2/pages';
import React from 'react';

const URL_PARAMETERS = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.PARAMETERS;
const URL_TRANSACTIONS = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.TRANSACTION_MENU;
const URL_ISSUER = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.ISSUER_MENU;
const URL_FEES = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.FEES_MENU;
const URL_MESSAGE = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.MESSAGE_MENU;
const URL_BATCHES = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.BATCHES;
const VisaBase2Routes = [
  // Parameters MENU ROUTES
  <Route>
    {parametersMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Transaction  MENU ROUTES
  <Route>
    {transactionMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Issuer  MENU ROUTES
  <Route>
    {issuerMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Fees  MENU ROUTES
  <Route>
    {feesMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Message  MENU ROUTES
  <Route>
    {messageMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Batches Route
  <Route>
    {batchesMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  
  
];

function parametersMenuRoutes() {
  return [
    <Route
      path={URL_PARAMETERS}
      element={<VisaBase2Module.Parameters />}
    />,
  ];
}

function transactionMenuRoutes() {
  return [
    <Route
      path={URL_TRANSACTIONS.VALID_TRANSACTION_CONSULTING}
      element={<VisaBase2Module.ValidTransactionConsulting />}
    />,
    <Route
      path={URL_TRANSACTIONS.VISA_TRANSACTION_STATUS}
      element={<VisaBase2Module.VisaTransactionStatus />}
    />,
    <Route
      path={URL_TRANSACTIONS.VISA_TRANSACTION_HISTORY}
      element={<VisaBase2Module.VisaTransactionHistory />}
    />,
    <Route
      path={URL_TRANSACTIONS.INCOMING_SUMMARY}
      element={<VisaBase2Module.IncomingSummary />}
    />,
    <Route
      path={URL_TRANSACTIONS.OUTGOING_SUMMARY}
      element={<VisaBase2Module.OutgoingSummary />}
    />,
    <Route
      path={URL_TRANSACTIONS.INCOMING_SUMMARY_DETAILS + ':id/'}
      element={<VisaBase2Module.IncomingSummaryDetails />}
    />,
    <Route
      path={URL_TRANSACTIONS.OUTGOING_SUMMARY_DETAILS + ':id/'}
      element={<VisaBase2Module.OutgoingSummaryDetails />}
    />,
    
    
  ];
}

function issuerMenuRoutes() {
  return [
    // PRESENTATION
    <Route
      path={URL_ISSUER.PRESENTATION_MENU.PRESENTATION_CONSULTATION}
      element={<VisaBase2Module.PresentationConsultation />}
    />,
    <Route
      path={URL_ISSUER.PRESENTATION_MENU.REPRESENTATION_CONSULTATION}
      element={<VisaBase2Module.RepresentationConsultation />}
    />,
    <Route
      path={URL_ISSUER.PRESENTATION_MENU.PRESENTATION_CANCELLATION_CONSULTATION}
      element={<VisaBase2Module.PresentationCancellationConsultation />}
    />,

    // // CHARGEBACK
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.CREATION}
      element={<VisaBase2Module.Creation />}
    />,
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.PRE_CONTROL_TREATMENT}
      element={<VisaBase2Module.PreControlTreatment />}
    />,
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.CONSULTATION}
      element={<VisaBase2Module.Consultation />}
    />,
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.REPROCESSING_OPERATION}
      element={<VisaBase2Module.ReprocessingOperation />}
    />,

    // // CHARGEBACK - CANCELLATION
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.CANCELLATION_MENU.CREATION}
      element={<VisaBase2Module.CancellationCreation />}
    />,
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.CANCELLATION_MENU.PRE_CONTROL_TREATMENT}
      element={<VisaBase2Module.CancellationPreControlTreatment />}
    />,
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.CANCELLATION_MENU.CONSULTATION}
      element={<VisaBase2Module.CancellationConsultation />}
    />,
    <Route
      path={URL_ISSUER.CHARGEBACK_MENU.CANCELLATION_MENU.REPROCESSING_OPERATION}
      element={<VisaBase2Module.CancellationReprocessingOperation />}
    />,

    // // REQUEST
    <Route
      path={URL_ISSUER.REQUEST_MENU.CREATION}
      element={<VisaBase2Module.RequestCreation />}
    />,
    <Route
      path={URL_ISSUER.REQUEST_MENU.PRE_CONTROL_TREATMENT}
      element={<VisaBase2Module.RequestPreControlTreatment />}
    />,
    <Route
      path={URL_ISSUER.REQUEST_MENU.CONSULTATION}
      element={<VisaBase2Module.RequestConsultation />}
    />,
    <Route
      path={URL_ISSUER.REQUEST_MENU.REPROCESSING_OPERATION}
      element={<VisaBase2Module.RequestReprocessingOperation />}
    />,
    
    // // CONSULTING_CONFIRMATION_REQUEST
    <Route
      path={URL_ISSUER.CONSULTING_CONFIRMATION_REQUEST}
      element={<VisaBase2Module.ConsultingConfirmationRequest />}
    />,
        
  ];
}

function feesMenuRoutes() {
  return [
    <Route
      path={URL_FEES.OUTGOING_MENU.CREATION}
      element={<VisaBase2Module.FeesOutgoingCreation />}
    />,
    <Route
      path={URL_FEES.OUTGOING_MENU.CONSULTATION}
      element={<VisaBase2Module.FeesOutgoingConsultation />}
    />,
    <Route
      path={URL_FEES.INCOMING_MENU.CONSULTATION}
      element={<VisaBase2Module.FeesIncomingConsultation />}
    />,
    <Route
      path={URL_FEES.INCOMING_MENU.CONSULTATION_DETAILS + ':id/'}
      element={<VisaBase2Module.FeesIncomingConsultationDetails />}
    />,
    
  ];
}

function messageMenuRoutes() {
  return [
    <Route
      path={URL_MESSAGE.OUTGOING_MENU.CREATION}
      element={<VisaBase2Module.MessageOutgoingCreation />}
    />,
    <Route
      path={URL_MESSAGE.OUTGOING_MENU.CONSULTATION}
      element={<VisaBase2Module.MessageOutgoingConsultation />}
    />,
    <Route
      path={URL_MESSAGE.INCOMING_MENU.CONSULTATION}
      element={<VisaBase2Module.MessageIncomingConsultation />}
    />,
    
  ];
}

function batchesMenuRoutes() {
  return [
    // Batches Menu Routes
    <Route
      path={URL_BATCHES.BATCHES_MONITORING}
      element={<VisaBase2Module.BatchesMonitoringPage />}
    />,
    <Route
      path={URL_BATCHES.BATCHES_ERRORS}
      element={<VisaBase2Module.BatchErrorsPage />}
    />,
    <Route
      path={URL_BATCHES.BATCHES_TRACES}
      element={<VisaBase2Module.BatchesTracksPage />}
    />,
  ];
}


export default VisaBase2Routes;
